module.exports = __webpack_public_path__ + "img/g-tit3.6d8fb9ab.png";